/* eslint-disable  */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { FaEye, FaEyeSlash, FaCamera, FaImages, FaTimes, FaCalendarAlt } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, useHistory } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { bindActionCreators } from "redux";
import "../../../css/Pages/Pages.css";
import { authActionCreators } from "../../../service/action-creators";
import Loader from "../../Loader";
import Resizer from "react-image-file-resizer";
import Webcam from "react-webcam";

function ChangePasswordAndEmail() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const [formData, setFormData] = useState({});
  const [profileImagePreview, setProfileImagePreview] = useState(null);
  const [resizedProfileImage, setResizedProfileImage] = useState(null);
  const [showCamera, setShowCamera] = useState(false);
  const webcamRef = useRef(null);
  const fileInputRef = useRef(null);
  const dobPickerRef = useRef(null);
  // CHANGED: Track the submitted email so we can pass it to the OTP verification page
  const [pendingEmail, setPendingEmail] = useState('');
  const [dobDisplay, setDobDisplay] = useState("");

  const { ChangePasswordAndEmail, ResetResponse, GetUserProfile } =
    bindActionCreators(authActionCreators, dispatch);
  const user = useSelector((state) => state.auth.user);
  const response = useSelector((state) => state.auth.response);
  const isLoading = useSelector((state) => state.auth.isLoading);

  const handlechange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleDobTextChange = (e) => {
    const raw = e.target.value.replace(/\D/g, "").slice(0, 8);
    let mm = raw.slice(0, 2);
    let dd = raw.slice(2, 4);
    const yyyy = raw.slice(4, 8);

    if (mm.length === 2) {
      const n = parseInt(mm, 10);
      if (n > 12) mm = "12";
      else if (n < 1) mm = "01";
    }
    if (dd.length === 2) {
      const n = parseInt(dd, 10);
      if (n > 31) dd = "31";
      else if (n < 1) dd = "01";
    }

    let formatted = mm;
    if (raw.length > 2) formatted = mm + "/" + dd;
    if (raw.length > 4) formatted = mm + "/" + dd + "/" + yyyy;

    setDobDisplay(formatted);
    if (raw.length === 8) {
      setFormData((prev) => ({ ...prev, dob: `${yyyy}-${mm}-${dd}` }));
    }
  };

  const handleDobPicked = (e) => {
    const val = e.target.value;
    if (val) {
      const [yyyy, mm, dd] = val.split("-");
      setDobDisplay(`${mm}/${dd}/${yyyy}`);
      setFormData((prev) => ({ ...prev, dob: val }));
    }
  };

  const openDobPicker = () => {
    if (dobPickerRef.current) {
      if (dobPickerRef.current.showPicker) {
        dobPickerRef.current.showPicker();
      } else {
        dobPickerRef.current.click();
      }
    }
  };

  useEffect(() => {
    GetUserProfile();
  }, []);

  useEffect(() => {
    if (user?.profile_image) {
      setResizedProfileImage(user?.profile_image);
    }
  }, [user]);

  useEffect(() => {
    if (user?.changed_password && user?.is_account_active) {
      history.push("/home");
    }
  }, [user?.changed_password, user?.is_account_active]);

  const handleProfileChange = (e) => {
    if (e?.target.files[0]) {
      const file = e?.target.files[0];
      const reader = new FileReader();

      reader.onload = (ev) => {
        setProfileImagePreview(ev?.target?.result);
        try {
          Resizer.imageFileResizer(
            e.target.files[0],
            100,
            100,
            "png",
            100,
            0,
            (uri) => {
              setResizedProfileImage(uri);
            },
            "file",
            200,
            200
          );
        } catch (err) {
          console.log(err);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  const capturePhoto = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (imageSrc) {
      setProfileImagePreview(imageSrc);
      const file = dataURLtoFile(imageSrc, "camera-capture.png");
      try {
        Resizer.imageFileResizer(
          file,
          100,
          100,
          "png",
          100,
          0,
          (uri) => {
            setResizedProfileImage(uri);
          },
          "file",
          200,
          200
        );
      } catch (err) {
        console.log(err);
      }
      setShowCamera(false);
    }
  }, [webcamRef]);

  const validateEmail = (email) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.password ||
      !formData.confirmPassword ||
      !formData.email ||
      !formData.phone_number
    ) {
      toast.error("All fields are required");
      return;
    } else if (formData.password !== formData.confirmPassword) {
      toast.error("Your password do not match");
    } else if (!resizedProfileImage) {
      toast.error("Please upload passport picture");
    } else if (!formData.dob) {
      toast.error("Date of birth is required");
    } else if (!validateEmail(formData.email)) {
      toast.error("Please enter a valid email address");
      return;
    } else if (formData.email !== formData.confirm_email) {
      toast.error("Please your email do not match");
      return;
    } else {
      // CHANGED: Store email before dispatch so the success redirect can pass it as a query param
      setPendingEmail(formData.email);
      ChangePasswordAndEmail(formData, resizedProfileImage);
    }
  };

  useEffect(() => {
    if (user?.changed_password && user?.email) {
      return <Redirect to={"/home"} />;
    }
  }, [user]);

  useEffect(() => {
    if (response.state === "SUCCESS") {
      toast.success(response?.message ?? "Please verify your email");
      ResetResponse();
      history.push(`/account/verifyemail?email=${encodeURIComponent(pendingEmail)}`);
    } else if (response.state === "ERROR") {
      toast.error(response?.message ?? "unable to update user");
      setTimeout(() => {
        ResetResponse();
      }, 1500);
    }
  }, [response.state]);

  const currentImage = profileImagePreview
    ? profileImagePreview.toString()
    : user?.profile_image;

  return (
    <div className="ConfirmEmailPassword">
      <div className="overlay">
        {isLoading && <Loader />}
        <form autoComplete="off" style={{ borderRadius: "1rem", boxShadow: "0 8px 32px rgba(0,0,0,0.10)" }}>
          <h3 className="title text-2xl font-bolder" style={{ marginBottom: "0.25rem" }}>
            {user?.name || "Unknown..."}
          </h3>
          <h6 className="title text-lg font-bold" style={{ marginBottom: "1.5rem", color: "#6b7280" }}>
            Update Your Profile
          </h6>

          {/* Profile Photo Section */}
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: "1.5rem" }}>
            <div
              style={{
                width: "120px",
                height: "120px",
                borderRadius: "50%",
                overflow: "hidden",
                border: "3px solid #e5e7eb",
                background: "#f9fafb",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "0.75rem",
              }}
            >
              {currentImage ? (
                <img
                  src={currentImage}
                  alt="Profile"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              ) : (
                <svg
                  style={{ width: "48px", height: "48px", color: "#9ca3af" }}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  />
                </svg>
              )}
            </div>

            <p style={{ fontSize: "0.8rem", color: "#6b7280", marginBottom: "0.5rem" }}>
              Upload your passport photo
            </p>

            <div style={{ display: "flex", gap: "0.75rem" }}>
              <button
                type="button"
                onClick={() => fileInputRef.current.click()}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.4rem",
                  padding: "0.5rem 1rem",
                  border: "1px solid #d1d5db",
                  borderRadius: "0.5rem",
                  background: "#fff",
                  cursor: "pointer",
                  fontSize: "0.8rem",
                  color: "#374151",
                  transition: "all 0.2s",
                }}
                onMouseOver={(e) => { e.currentTarget.style.background = "#f3f4f6"; }}
                onMouseOut={(e) => { e.currentTarget.style.background = "#fff"; }}
              >
                <FaImages style={{ color: "#6366f1" }} />
                Gallery
              </button>
              <button
                type="button"
                onClick={() => setShowCamera(true)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.4rem",
                  padding: "0.5rem 1rem",
                  border: "1px solid #d1d5db",
                  borderRadius: "0.5rem",
                  background: "#fff",
                  cursor: "pointer",
                  fontSize: "0.8rem",
                  color: "#374151",
                  transition: "all 0.2s",
                }}
                onMouseOver={(e) => { e.currentTarget.style.background = "#f3f4f6"; }}
                onMouseOut={(e) => { e.currentTarget.style.background = "#fff"; }}
              >
                <FaCamera style={{ color: "#6366f1" }} />
                Camera
              </button>
            </div>

            <input
              ref={fileInputRef}
              onChange={handleProfileChange}
              type="file"
              accept="image/*"
              style={{ display: "none" }}
            />
          </div>

          {/* Webcam Modal */}
          {showCamera && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(0,0,0,0.7)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1000,
              }}
            >
              <div
                style={{
                  background: "#fff",
                  borderRadius: "1rem",
                  padding: "1.5rem",
                  width: "90%",
                  maxWidth: "420px",
                  textAlign: "center",
                  position: "relative",
                }}
              >
                <button
                  type="button"
                  onClick={() => setShowCamera(false)}
                  style={{
                    position: "absolute",
                    top: "0.75rem",
                    right: "0.75rem",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "1.2rem",
                    color: "#6b7280",
                  }}
                >
                  <FaTimes />
                </button>

                <h4 style={{ marginBottom: "1rem", fontWeight: 600, color: "#1f2937" }}>
                  Take a Photo
                </h4>

                <div style={{ borderRadius: "0.75rem", overflow: "hidden", marginBottom: "1rem" }}>
                  <Webcam
                    ref={webcamRef}
                    audio={false}
                    screenshotFormat="image/png"
                    videoConstraints={{ facingMode: "user", width: 400, height: 400 }}
                    style={{ width: "100%", borderRadius: "0.75rem" }}
                  />
                </div>

                <button
                  type="button"
                  onClick={capturePhoto}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    padding: "0.65rem 2rem",
                    background: "#6366f1",
                    color: "#fff",
                    border: "none",
                    borderRadius: "0.5rem",
                    cursor: "pointer",
                    fontSize: "0.9rem",
                    fontWeight: 500,
                  }}
                >
                  <FaCamera />
                  Capture
                </button>
              </div>
            </div>
          )}

          {/* Email Fields */}
          <div className="row">
            <div className="formInput col-md-6">
              <label style={{ fontSize: "0.85rem", fontWeight: 500, color: "#374151" }}>
                Email Address
              </label>
              <input
                type="email"
                name="email"
                required
                autoComplete="false"
                placeholder="example@gmail.com"
                className="form-control"
                onChange={handlechange}
                style={{ borderRadius: "0.5rem" }}
              />
            </div>
            <div className="formInput col-md-6">
              <label style={{ fontSize: "0.85rem", fontWeight: 500, color: "#374151" }}>
                Confirm Email Address
              </label>
              <input
                type="email"
                name="confirm_email"
                required
                autoComplete="false"
                placeholder="Confirm email"
                className="form-control"
                onChange={handlechange}
                style={{ borderRadius: "0.5rem" }}
              />
            </div>
          </div>

          {/* Phone & DOB */}
          <div className="row">
            <div className="formInput col-md-6">
              <label style={{ fontSize: "0.85rem", fontWeight: 500, color: "#374151" }}>
                Phone Number
              </label>
              <input
                type="text"
                name="phone_number"
                required
                autoComplete="false"
                placeholder="Enter phone number"
                className="form-control"
                onChange={handlechange}
                style={{ borderRadius: "0.5rem" }}
              />
            </div>
            <div className="formInput col-md-6">
              <label style={{ fontSize: "0.85rem", fontWeight: 500, color: "#374151" }}>
                Date of Birth
              </label>
              <div style={{ position: "relative" }}>
                <input
                  type="text"
                  value={dobDisplay}
                  onChange={handleDobTextChange}
                  placeholder="mm/dd/yyyy"
                  className="form-control"
                  style={{ borderRadius: "0.5rem", paddingRight: "2.5rem" }}
                />
                <button
                  type="button"
                  onClick={openDobPicker}
                  style={{
                    position: "absolute",
                    right: "0.6rem",
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "none",
                    border: "none",
                    padding: 0,
                    cursor: "pointer",
                    color: "#6366f1",
                    fontSize: "1rem",
                    lineHeight: 1,
                  }}
                >
                  <FaCalendarAlt />
                </button>
                <input
                  ref={dobPickerRef}
                  type="date"
                  onChange={handleDobPicked}
                  style={{ position: "absolute", opacity: 0, width: 0, height: 0, pointerEvents: "none" }}
                  tabIndex={-1}
                />
              </div>
            </div>
          </div>

          {/* Password Fields */}
          <div className="row">
            <div className="formInput col-md-6">
              <label style={{ fontSize: "0.85rem", fontWeight: 500, color: "#374151" }}>
                New Password
              </label>
              <div className="inputGroup">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Enter new password"
                  className="form-control"
                  onChange={handlechange}
                  style={{ borderRadius: "0.5rem" }}
                />
                <span
                  className="icon"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEye /> : <FaEyeSlash />}
                </span>
              </div>
            </div>
            <div className="formInput col-md-6">
              <label style={{ fontSize: "0.85rem", fontWeight: 500, color: "#374151" }}>
                Confirm Password
              </label>
              <div className="inputGroup">
                <input
                  type={showPasswordConfirm ? "text" : "password"}
                  name="confirmPassword"
                  placeholder="Confirm password"
                  className="form-control"
                  onChange={handlechange}
                  style={{ borderRadius: "0.5rem" }}
                />
                <span
                  className="icon"
                  onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}
                >
                  {showPasswordConfirm ? <FaEye /> : <FaEyeSlash />}
                </span>
              </div>
            </div>
          </div>

          {/* Submit */}
          <div style={{ display: "flex", justifyContent: "center", marginTop: "0.5rem" }}>
            <button
              className="button"
              onClick={handleSubmit}
              style={{
                borderRadius: "0.5rem",
                padding: "0.65rem 3rem",
                fontWeight: 500,
              }}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
      <ToastContainer autoClose={3000} />
    </div>
  );
}

export default ChangePasswordAndEmail;
